import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface AppliancesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Appliances: React.FC<AppliancesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [appliances, set_appliances] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Appliances']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Appliances': [b.values?.['Interior']?.['Appliances']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Appliances';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(appliances)}
                />
            ) : (
                <MoneyBox
                    id={'appliances'}
                    allowNegative={false}
                    value={appliances}
                    onChange={(value) => set_appliances(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
